import { Stack, XStack } from 'tamagui'
import { Animated } from 'react-native'
import { HeroIcon } from '@components/HeroIcon'
import { CoverImage } from '@components/CoverImage'
import { LessonTypeTranslation } from '@utils/lessonMediaType'
import { ICourseContentsNodes, ICoverImage } from '@dtos/Course'

interface ILessonThumbnailProps {
  scaleValue: Animated.Value | number
  isLessonAvailable: boolean
  displayThumbnail: ICoverImage | boolean | null
  imageProps: {
    style: { borderRadius: number }
    source: { uri: string | undefined; height: number }
  }
  lessonTypeContainerHeight: number
  lessonIconColor: string
  lessonData: ICourseContentsNodes
}

export function LessonThumbnail({
  scaleValue,
  isLessonAvailable,
  displayThumbnail,
  imageProps,
  lessonTypeContainerHeight,
  lessonIconColor,
  lessonData,
}: ILessonThumbnailProps) {
  return (
    <Stack overflow="hidden" borderRadius={8}>
      <Animated.View
        style={{
          transform: [{ scale: scaleValue }],
        }}
      >
        {isLessonAvailable === false && (
          <Stack
            bg="$bg-locked"
            borderRadius="$border-radius-pill"
            position="absolute"
            zIndex={100}
            padding={8}
            right={10}
            top={10}
          >
            <HeroIcon
              icon={['fal', 'lock-keyhole']}
              color="$text-on-locked"
              size={25}
            />
          </Stack>
        )}
        {displayThumbnail ? (
          <CoverImage
            uri={imageProps.source.uri}
            height={imageProps.source.height}
            borderRadius={imageProps.style.borderRadius}
            grayscale={!isLessonAvailable}
            alt=""
          />
        ) : (
          <XStack
            borderRadius={8}
            bg="$bg-surface-sunken"
            alignItems="center"
            justifyContent="center"
            height={lessonTypeContainerHeight}
          >
            <HeroIcon
              icon={LessonTypeTranslation(
                lessonData.lesson.activity !== null
                  ? 'Quiz'
                  : lessonData.lesson.media?.type || 'Text',
              )}
              color={lessonIconColor}
              size={50}
            />
          </XStack>
        )}
      </Animated.View>
    </Stack>
  )
}
